import { MINERVA_ONDEMAND_IDS } from './constants';

export const hasOndemandClasses = ({ planId }) => MINERVA_ONDEMAND_IDS.includes(planId);
